export const DECLARE_OF_INTEREST_ERROR =
  "Error submitting Declaration of interest. Please contact us at support@varsome.com.";
export const CONNECTION_REQUEST_ERROR =
  "Error submitting connection request. Please contact us at support@varsome.com.";
